import React from "react";
import MainHeader from "components/templateParts/MainHeader";
import SearchBar from "components/templateParts/SearchBar";
import SmartViewsSidebar from "../../../SmartViewsSidebar/SmartViewsSidebar";
import AddPostButton from "../../../ui_components/buttons/AddPostButton";
import Footer from "components/Footer/Footer";
import { BaseListComponent } from "components/base";
import { smartFilterConfig } from "config/resources/clientsResource/index.js";
import ExportAllButton from "components/ui_components/buttons/ExportAllButton.js";
import { userRoles } from "config/userRoles";
import { canNotByRoles } from "utils/permissions";

const ClientsListComponent = (props) => {
  const isEditAvailable = canNotByRoles([userRoles.sales]);

  return (
    <div>
      <MainHeader
        title="Clients"
        button={
          isEditAvailable && (
            <AddPostButton title="Clients" href="/clients/create" />
          )
        }
      />
      <SearchBar />
      <SmartViewsSidebar
        isOpen={true}
        resource="clients"
        smartFilterConfig={smartFilterConfig}
      >
        <div className="mainContainer">
          <div className="mainContainer__inner">
            <BaseListComponent
              {...props}
              editableTable={isEditAvailable}
              showDelete={isEditAvailable}
              deleteConfirmationMessagePostfix="client"
              toolbarExtraComponents={
                <ExportAllButton resource="clients/export" />
              }
            />
          </div>
          <Footer />
        </div>
      </SmartViewsSidebar>
    </div>
  );
};

export default ClientsListComponent;
